// Form values are ids, not labels: a label lookup loses ids the catalog no longer lists.
export const toFormGameIds = (gameIds?: number[]): string[] => (gameIds || []).map(String)

// No default: an empty list is "boost every game" server-side, so it must be chosen, never defaulted.
export const toStoredGameIds = (values: (string | number)[]): number[] => values.map(Number)
